import axios from 'axios';

const apiURL = process.env.REACT_APP_API_URL;

// Create an Axios instance
const apiClient = axios.create({
    baseURL: apiURL,
});

// Add a request interceptor to attach the token
apiClient.interceptors.request.use((config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Add a response interceptor to handle expired/invalid sessions globally.
// This is a complementary safety net for every endpoint other than the
// `/me` polling handled explicitly in `src/Router/router.jsx`.
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;

        if (status === 401) {
            const requestUrl = error?.config?.url || '';
            const isAuthRequest = /\/(auth|signin|login)(\/|$|\?)/i.test(requestUrl);
            const isOnSignInPage = window.location.pathname === '/signin';

            // Avoid redirect loops: skip when the 401 came from an auth
            // endpoint itself (e.g. a failed login attempt) or when we are
            // already on the sign-in page.
            if (!isAuthRequest && !isOnSignInPage) {
                sessionStorage.removeItem('token');
                window.location.href = '/signin';
            }
        }

        return Promise.reject(error);
    }
);

export default apiClient;